import AddIcon from '@mui/icons-material/Add';
import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetContractsQuery } from '../../api/contractSlice';
import { UserContext } from '../Hooks/useUser';
import ContractEntry from './ContractEntry';

function ContractIntelligence() {
    const { user } = useContext(UserContext);
    const navigate = useNavigate();
    const { data: contracts = [], isLoading } = useGetContractsQuery({ organizationId: user.organization.id });

    return (
        <Stack spacing={2} px={{ xs: 2, md: 4 }} pb={3}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Stack spacing={0.5}>
                    <Typography variant="heavy" sx={{ fontSize: '22px' }}>
                        Contracts
                    </Typography>
                    {!isLoading && (
                        <Typography variant="normal" sx={{ fontSize: '14px', color: 'subtext.main' }}>
                            {contracts.length} contract{contracts.length !== 1 ? 's' : ''}
                        </Typography>
                    )}
                </Stack>
                <Button
                    variant="blueContained"
                    startIcon={<AddIcon />}
                    onClick={() => navigate('/contracts/create')}
                >
                    Add Contract
                </Button>
            </Stack>

            {isLoading ? (
                <Stack alignItems="center" py={6}>
                    <CircularProgress size={28} />
                </Stack>
            ) : (
                <Stack spacing={2}>
                    {contracts.map((contract) => (
                        <ContractEntry
                            key={contract.id}
                            contract={contract}
                            onClick={() => navigate(`/contracts/${contract.id}`)}
                        />
                    ))}
                    {contracts.length === 0 && (
                        <Typography sx={{ color: 'subtext.main', fontSize: '14px', textAlign: 'center', py: 6 }}>
                            No contracts yet. Add one to get started.
                        </Typography>
                    )}
                </Stack>
            )}
        </Stack>
    );
}

export default ContractIntelligence;
